import { GroupFilter } from '@getaccept/lib-shared/src/enums/group-filter';
import { computed, watch } from '@vue/composition-api';
import { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import { storeToRefs } from 'pinia';
import { useLocalStorage } from '@vueuse/core';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { useSessionStore } from '../session/store/session.store';
import { useUserStore } from '../user/store/user.store';
import { useModulesStore } from '../modules/store/modules.store';
import router from '../router/router';

export const useGroupFilter = ({ allowTeam } = { allowTeam: true }) => {
  const { session } = storeToRefs(useSessionStore());
  const { user } = storeToRefs(useUserStore());
  const { isDealRoomModuleActive } = storeToRefs(useModulesStore());
  const userRole = computed(() => session.value.user_role);
  const groupFilterRef = useLocalStorage<GroupFilter>('groupFilter', GroupFilter.All);

  const watchUser = () => {
    if (groupFilterRef.value === GroupFilter.All && userRole.value !== UserRoleLegacy.Admin) {
      groupFilterRef.value = GroupFilter.My;
    }
    if (
      groupFilterRef.value === GroupFilter.Team &&
      [UserRoleLegacy.Admin, UserRoleLegacy.Manager].includes(userRole.value)
    ) {
      groupFilterRef.value = GroupFilter.My;
    }
  };
  watch(userRole, watchUser, { immediate: true });

  const groupFilter = computed({
    get() {
      return !allowTeam && groupFilterRef.value === GroupFilter.Team
        ? GroupFilter.My
        : groupFilterRef.value;
    },
    set(value: GroupFilter) {
      groupFilterRef.value = value;
    },
  });

  const isDealroomLibrary = computed(
    () => isDealRoomModuleActive.value && router.currentRoute.name === PathName.Library
  );

  const getGroupTabs = computed(() => {
    const allTabs = [
      {
        label: t('show-mine'),
        key: GroupFilter.My,
        show: true,
      },
      {
        label: t('show-team'),
        key: GroupFilter.Team,
        show: allowTeam && session.value.team_count > 0 && !!user.value?.team?.id,
      },
      {
        label: t('show-all'),
        key: GroupFilter.All,
        show: userRole.value === UserRoleLegacy.Admin || isDealroomLibrary.value,
      },
    ];
    return allTabs.filter(({ show }) => show).map(({ label, key }) => ({ label, key }));
  });

  return {
    groupFilter,
    getGroupTabs,
  };
};
